import request from "request";

export const pollWithRetryPromise = () => {
  let intervalId = null;
  let timeoutId = null;
  let finished = false;
  let abortController = new AbortController();

  const cleanup = () => {
    finished = true;
    if (intervalId) clearInterval(intervalId);
    if (timeoutId) clearTimeout(timeoutId);
    if (abortController) abortController.abort();
    intervalId = null;
    timeoutId = null;
  };

  const pollingPromise = ({
    url,
    form,
    interval = 5000,
    timeout = 300000, // 5 minutes
    retryUrl = null,
    retryForm = {},
    token,
  }) => {
    console.log("Polling started with URL:", url);
    return new Promise((resolve, reject) => {
      const handleResponse = response => {
        if (response && response.data) {
          cleanup();
          resolve(response.data);
        } else if (response && response.key) {
          // Start polling with retry if not already started
          if (!intervalId) {
            intervalId = setInterval(() => {
              if (finished) {
                return;
              }
              retryUsingFetch();
            }, interval);
          }
        } else {
          cleanup();
          reject(new Error("Unexpected response"));
        }
      };

      const sendRequest = () => {
        if (finished) {
          return;
        }
        const headers = {
          "Content-Type": "application/x-www-form-urlencoded",
        };
        if (token) {
          headers.Authorization = token;
        }
        request.post(
          {
            url,
            headers,
            form,
          },
          (err, res, data) => {
            if (finished) {
              return;
            }
            if (err || res.statusCode >= 400) {
              cleanup();
              reject(err || new Error(`Status ${res && res.statusCode}`));
              return;
            }
            let response;
            try {
              response = JSON.parse(data);
            } catch (e) {
              cleanup();
              reject(new Error("Invalid JSON response"));
              return;
            }
            handleResponse(response);
          }
        );
      };

      const retryUsingFetch = () => {
        if (finished) return;
        fetch(retryUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            Authorization: token,
          },
          body: new URLSearchParams(retryForm).toString(),
          signal: abortController.signal,
        })
          .then(response => {
            if (!response.ok) throw new Error("Network response was not ok");
            return response.json();
          })
          .then(data => {
            if (finished) return;
            handleResponse(data);
          })
          .catch(error => {
            if (finished) return;
            cleanup();
            reject(error);
          });
      };

      sendRequest();

      timeoutId = setTimeout(() => {
        if (finished) return;
        cleanup();
        reject(
          new Error("Polling timed out after 5 minutes. Stopping retries.")
        );
      }, timeout);
    });
  };
  return { pollingPromise, cleanup };
};
